import './index.erb';
import './index.rb';

$(document).on('turbolinks:load', function () {
  const initDropdown = () => {
    $('.dropdown').on('click', function () {
      const $dropdown = $(this).closest('.dropdown');
      const $dropdownMenu = $dropdown.find('.dropdown-menu');

      $('.dropdown').not($dropdown).removeClass('active');
      $('.dropdown-menu').not($dropdownMenu).hide();

      $('.segment-button').removeClass('active');
      $('#segmentNewMenu').hide();

      $dropdown.toggleClass('active');
      $dropdownMenu.toggle();
    });

    $(document).on('click', function (e) {
      if (!$(e.target).closest('.dropdown').length) {
        $('.dropdown').removeClass('active');
        $('.dropdown-menu').hide();
      }
    });
  };

  initDropdown();
});
